export default __webpack_public_path__ + "static/media/img-hero.48394c50.png";